
import React, { useEffect, useState } from "react";
import { Offcanvas, Form, Button } from "react-bootstrap";

const LoanModal = ({
  showModal,
  handleClose,
  LoanData,
  addLoan,
  editLoan,
  LoanId,
  employees,
  fetchEmployees,
}) => {
  const [formData, setFormData] = useState({
    title: "",
    employee_id: "",
    loan_amount: "",
    total_month: "",
    installment_amount: "",
    start_date: "",
    end_date: "",
    remarks: "",
  });

  const [errors, setErrors] = useState({});

  useEffect(() => {
    fetchEmployees();
  }, []);

  useEffect(() => {
    if (showModal && !LoanData) {
      // reset form
      setFormData({
        title: "",
        employee_id: "",
        loan_amount: "",
        total_month: "",
        installment_amount: "",
        start_date: "",
        end_date: "",
        remarks: "",
      });
    } else if (LoanData) {
      // edit mode
      setFormData({
        ...LoanData,
      });
    }
  }, [LoanData, showModal]);

  // Auto-calc installment when loan_amount & total_month are entered
  useEffect(() => {
    if (formData.loan_amount && formData.total_month) {
      const monthly = parseFloat(formData.loan_amount) / parseInt(formData.total_month);
      setFormData((prev) => ({
        ...prev,
        installment_amount: isNaN(monthly) ? "" : monthly.toFixed(2),
      }));
    }
  }, [formData.loan_amount, formData.total_month]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
    if (errors[name]) {
      setErrors((prev) => ({ ...prev, [name]: undefined }));
    }
  };

  const validateForm = () => {
    const newErrors = {};
    if (!formData.title) newErrors.title = "Loan title is required";
    if (!formData.employee_id) newErrors.employee_id = "Employee is required";
    if (!formData.loan_amount) newErrors.loan_amount = "Loan amount is required";
    if (!formData.total_month) newErrors.total_month = "Total months required";
    return newErrors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const validationErrors = validateForm();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    let apierrors;
    if (LoanData) {
      apierrors = await editLoan(LoanId, formData);
    } else {
      apierrors = await addLoan(formData);
    }

    if (apierrors && Object.keys(apierrors).length > 0) {
      setErrors(apierrors);
    } else {
      setErrors({});
      handleClose();
    }
  };

  return (
    <Offcanvas
      show={showModal}
      onHide={handleClose}
      placement="end"
      style={{ width: "450px" }}
    >
      <Offcanvas.Header closeButton className="bg-light">
        <Offcanvas.Title className="fw-bold">
          {LoanData ? "Edit Loan" : "Add New Loan"}
        </Offcanvas.Title>
      </Offcanvas.Header>

      <Offcanvas.Body className="p-4" style={{ overflowY: "auto" }}>
        <Form onSubmit={handleSubmit}>
          <Form.Group className="mb-3">
            <Form.Label className="form-font">Title *</Form.Label>
            <Form.Control
              type="text"
              name="title"
              value={formData.title}
              onChange={handleChange}
              isInvalid={!!errors.title}
              className="form-control form-feild"
            />
            <Form.Control.Feedback type="invalid">
              {errors.title}
            </Form.Control.Feedback>
          </Form.Group>
<Form.Group className="mb-3">
            <Form.Label className="form-font">Loan Date</Form.Label>
            <Form.Control
              type="date"
              name="start_date"
              value={formData.start_date || ""}
              onChange={handleChange}
              className="form-control form-feild"
            />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label className="form-font">Employee *</Form.Label>
            <Form.Select
              name="employee_id"
              value={formData.employee_id}
              onChange={handleChange}
              isInvalid={!!errors.employee_id}
              className="form-feild"
            >
              <option value="">-- Select Employee --</option>
              {employees.map((emp) => (
                <option key={emp.id} value={emp.id}>
                  {emp.first_name} {emp.last_name}
                </option>
              ))}
            </Form.Select>
            <Form.Control.Feedback type="invalid">
              {errors.employee_id}
            </Form.Control.Feedback>
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label className="form-font">Loan Amount *</Form.Label>
            <Form.Control
              type="number"
              name="loan_amount"
              value={formData.loan_amount}
              onChange={handleChange}
              isInvalid={!!errors.loan_amount}
              className="form-feild"
            />
            <Form.Control.Feedback type="invalid">
              {errors.loan_amount}
            </Form.Control.Feedback>
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label className="form-font">Total Months *</Form.Label>
            <Form.Control
              type="number"
              name="total_month"
              value={formData.total_month}
              onChange={handleChange}
              isInvalid={!!errors.total_month}
              className="form-feild"
            />
            <Form.Control.Feedback type="invalid">
              {errors.total_month}
            </Form.Control.Feedback>
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label className="form-font">Monthly Installment</Form.Label>
            <Form.Control
              type="text"
              name="installment_amount"
              value={formData.installment_amount}
              readOnly
              className="form-control form-feild"
            />
          </Form.Group>

          

          {/* <Form.Group className="mb-3">
            <Form.Label>End Date</Form.Label>
            <Form.Control
              type="date"
              name="end_date"
              value={formData.end_date || ""}
              onChange={handleChange}
            />
          </Form.Group> */}

          <Form.Group className="mb-3">
            <Form.Label className="form-font">Remarks</Form.Label>
            <Form.Control
              as="textarea"
              rows={3}
              name="remarks"
              value={formData.remarks}
              onChange={handleChange}
              className="form-control"
            />
          </Form.Group>

          <div className="d-flex justify-content-end mt-4">
            <Button variant="outline-secondary" onClick={handleClose} className="me-2">
              Cancel
            </Button>
            <Button variant="primary" type="submit">
              Save
            </Button>
          </div>
        </Form>
      </Offcanvas.Body>
    </Offcanvas>
  );
};

export default LoanModal;
